/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForSaasMicrosoftTeams extends models.ServiceAccountNativeDetailsBaseForSaasOtherServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForSaasMicrosoftTeams");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForSaasMicrosoftTeams.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForSaasMicrosoftTeams>): ServiceAccountNativeDetailsForSaasMicrosoftTeams {
        let obj = Object.assign(new ServiceAccountNativeDetailsForSaasMicrosoftTeams(), model);
        ServiceAccountNativeDetailsForSaasMicrosoftTeams.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForSaasMicrosoftTeams>): ServiceAccountNativeDetailsForSaasMicrosoftTeams {
        if (!model) return null;
        return ServiceAccountNativeDetailsForSaasMicrosoftTeams.newInstance(<ServiceAccountNativeDetailsForSaasMicrosoftTeams> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForSaasMicrosoftTeams) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForSaasMicrosoftTeams.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForSaasMicrosoftTeams): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForSaasMicrosoftTeams.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
